import { useEffect, useState } from 'react';

export const usePOARenderControl = (hasUploadedDocuments: boolean) => {
  const [previouslyUploaded, setPreviouslyUploaded] = useState(false);

  useEffect(() => {
    if (hasUploadedDocuments) {
      setPreviouslyUploaded(true);
    }
  }, [hasUploadedDocuments, previouslyUploaded]);

  return !hasUploadedDocuments && !previouslyUploaded;
};
